<main id="content" role="main" class="govuk-main-wrapper--l">
  <div class="govuk-grid-row">
    <div class="govuk-grid-column-two-thirds">
      <div class="govuk-!-margin-bottom-8">
        <h1 class="govuk-heading-xl">Thank you for contacting GOV.UK</h1>
      </div>

      <p class="govuk-body">
        Your message has been sent, and the team will get back to you to answer
        any questions as soon as possible.
      </p>
      <p class="govuk-body">
        <a class="govuk-link" href="#" (click)="restartJourney()"
          >Return to journey</a
        >.
      </p>
    </div>
  </div>
</main>
